export const doesMatchMedia = query => {
  const { matches } = window.matchMedia(query);

  return matches;
};
